import type { Crop, PixelCrop } from 'react-image-crop'
import type { Bounds } from '../../types'

type HelperProps = {
  image: HTMLImageElement | null
  crop: Crop | PixelCrop | undefined
  zoom: number
  containerWidth?: number
  containerHeight?: number
}

const getPanBounds = ({
  image,
  crop,
  zoom,
  containerWidth,
  containerHeight,
}: HelperProps): Bounds => {
  if (!image || !crop?.width || !crop?.height) {
    return { minX: -Infinity, maxX: Infinity, minY: -Infinity, maxY: Infinity }
  }

  const containerW = containerWidth ?? image.width
  const containerH = containerHeight ?? image.height

  const padX = Math.max(0, containerW - image.width) / 2
  const padY = Math.max(0, containerH - image.height) / 2

  const cropLeft = (crop.x ?? 0) - padX
  const cropTop = (crop.y ?? 0) - padY
  const cropRight = cropLeft + (crop.width ?? 0)
  const cropBottom = cropTop + (crop.height ?? 0)

  const shiftX = (image.width * (1 - zoom)) / 2
  const shiftY = (image.height * (1 - zoom)) / 2

  const minX = cropRight - image.width * ((zoom + 1) / 2)
  const maxX = cropLeft - shiftX
  const minY = cropBottom - image.height * ((zoom + 1) / 2)
  const maxY = cropTop - shiftY

  return { minX, maxX, minY, maxY }
}

export default getPanBounds
